import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Event, Router, NavigationStart, NavigationEnd } from '@angular/router';
import { AuthService } from '@core';
import { Subject } from 'rxjs';
import { GlobalService } from './services/global.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements AfterViewInit {
  @ViewChild('trapContainer', { static: false }) trapContainer!: ElementRef;
  currentUrl!: string;
  isLoading: Subject<boolean> = this._global.isLoading;
  constructor(public _router: Router, private authService: AuthService, private _global: GlobalService, private _auth: AuthService) {
    // Load the global carrier once the user (with facility info) is available,
    // since the carrier is chosen by the user's environment type.
    this._auth.currentUser?.subscribe((user: any) => {
      if (user?.facilityInfo) {
        this._global.loadCarrier();
      }
    });
    this._router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf('/') + 1
        );
      }
      if (routerEvent instanceof NavigationEnd) {
        /* empty */
      }
      window.scrollTo(0, 0);
    });
    window.onbeforeunload = () => {
      if (!_auth.isLoggedIn)
        this.authService.logout();
      // window.localStorage.setItem('opentabs', '0');

    }
    window.onhashchange = function () {
      console.log("HASHHHHHHHHHHHH.........");

    }
    history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', () => {
      console.log("==========================================POPSTATE===========================================-----------------------");
      console.log(window.location.href);
      const currentUrl = window.location.href;

      const match = currentUrl.match(/products\/product\/([^/]+)\/[^/]*$/);
      console.log(match);

      if (match && match?.length > 0) {
        const productId = match[1];

        console.log("----------------------");


        const newUrl = currentUrl.replace(/products\/product\/([^/]+)\/[^/]*$/, `products/product/${productId}/Shippingdetails`);

        console.log("----------------------", newUrl);
        this._router.navigateByUrl(newUrl);

        history.replaceState(null, '', newUrl);
      }

      // history.pushState(null, '', window.location.href);
    });

    _router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // console.log("+++++++++++++++++++++++++++++++++++++", event);
        this.isLoading.next(false);
      }
    })
  }

  ngAfterViewInit(): void {
    this.trapFocus(this.trapContainer.nativeElement);
  }

  trapFocus(element: HTMLElement) {
    const focusableElements = element.querySelectorAll(
      'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
    );

    if (focusableElements.length === 0) {
      console.warn('No focusable elements inside trap container');
      return;
    }

    const firstElement = focusableElements[0] as HTMLElement;
    const lastElement = focusableElements[focusableElements.length - 1] as HTMLElement;

    // Force focus to stay inside the container
    document.addEventListener('focusin', (event) => {
      if (!element.contains(event.target as Node)) {
        event.preventDefault();
        firstElement.focus();
      }
    });

    // Handle Tab key manually
    element.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Tab') {
        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    });

    // Set initial focus inside container
    firstElement.focus();
  }



}
